<template>
  <div
    class="transition-all translate-y-2 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 absolute bottom-full mb-2 -left-2 pointer-events-none bg-myflowMagenta shadow-md text-white py-1 px-2 text-xs rounded-md text-left"
  >
    <slot></slot>
  </div>
</template>
